import { Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ShopChannelCheckoutDetailByCodeGQL,
  ShopChannelDetailByCodeGQL,
  ShopChannelsGQL,
  ShopSuggestChannelsGQL,
} from './gql/shop-channel.gql.generated';
import {
  IShopChannelCheckoutDetail,
  IShopChannelDetail,
  IShopChannelItem,
  IShopSuggestChannels,
  IShopSuggestChannelsQuery,
} from './types/shop-channel';

@Injectable()
export class ShopChannelService {
  constructor(
    private readonly allChannelGql: ShopChannelsGQL,
    private readonly channelByCodeGql: ShopChannelDetailByCodeGQL,
    private readonly channelCheckoutDetailByCodeGQL: ShopChannelCheckoutDetailByCodeGQL,
    private readonly shopSuggestChannelsGQL: ShopSuggestChannelsGQL,
  ) {}

  fetchAllChannels(locale: string): Observable<IShopChannelItem[]> {
    return this.allChannelGql.fetch({ locale }).pipe(map((r) => r.data.shopChannels));
  }

  fetchChannelDetail(code: string, locale: string): Observable<IShopChannelDetail> {
    return this.channelByCodeGql.fetch({ code, locale }).pipe(map((r) => r.data.shopChannel));
  }

  fetchChannelCheckoutDetail(code: string, locale: string): Observable<IShopChannelCheckoutDetail> {
    return this.channelCheckoutDetailByCodeGQL
      .fetch({ code, locale })
      .pipe(map((r) => r.data.shopChannel));
  }

  fetchChannelSuggestions(query: IShopSuggestChannelsQuery): Observable<IShopSuggestChannels> {
    return this.shopSuggestChannelsGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopSuggestChannels));
  }
}
